import { Platform } from 'react-native';

export function loadScript(id: string, url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const exists = document.getElementById(id);
    if (exists) {
      resolve();
      return;
    }
    const el = document.createElement('script');
    el.src = url;
    el.id = id;
    el.onload = () => resolve();
    el.onerror = () => reject();
    document.body.appendChild(el);
  });
}

const EMPTY_OBJECT = Object.freeze({}) as any;

export function getQueryParams() {
  if (Platform.OS !== 'web') {
    return EMPTY_OBJECT;
  }

  const params = new URLSearchParams(window.location.search);
  const paramsObj: { [key: string]: string } = {};
  for (const [key, value] of params.entries()) {
    paramsObj[key] = value;
  }
  return paramsObj;
}

// Remove all query parameters from the URL
export const removeAllQueryParams = () => {
  if (Platform.OS !== 'web') {
    return;
  }
  const url = new URL(window.location.href);
  url.search = '';
  window.history.replaceState({}, '', url);
};

export const removeIsRedirectedParam = () => {
  if (Platform.OS !== 'web') {
    return;
  }
  const url = new URL(window.location.href);
  url.searchParams.delete('isRedirected');
  url.searchParams.delete('singleUseCardToken');
  window.history.replaceState({}, '', url);
};
